import { Metadata } from '../../../../../utils/spds/metadata';
import Super from '../../../core/button.gjs';
import styles from './secondary.module.scss';

const METADATA = Metadata.define({
  description: `
    Agent secondary button used to perform an action.

    Extends the SPDS Core Button component.
  `,
  name: 'Agent Secondary Button',
  resources: {
    figma: 'https://www.figma.com/design/pAAy83e2t59aYqNR2Vhi2C/Sidekick-AI?node-id=354-6530&m=dev',
    zeroheight: 'https://www.simplepractice.design/1d0abbc0a/v/0/p/56566c-buttons',
  },
});

export default class SpdsActionButtonAgentSecondary extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-button spds-action-button';
  variantClass = 'spds-action-button-agent-secondary';
  variantStyles = styles;

  get variant() {
    return 'agent-secondary';
  }
}

export const ACTION_BUTTON_AGENT_SECONDARY_METADATA = SpdsActionButtonAgentSecondary.metadata;
